module.exports = __webpack_public_path__ + "img/questions-bg.png?3b5b857dbe82f56850b7f17d6f61ce2f";